import { useTranslation } from 'react-i18next'
import SuccessModal from '@/components/success-modal'
import { createModal } from '@/components/modalize/mui'

type ConfirmProps = {
  type: 'delete' | 'edit'
}

const ConfirmPayment: React.FC<ConfirmProps> = ({ type }) => {
  const wasDeleted = type === 'delete'
  const { t } = useTranslation()
  return (
    <SuccessModal
      title={
        wasDeleted
          ? t('l.settings.view.plan_settings.payment_method.deleted.title', 'Card Deleted!')
          : t('l.settings.view.plan_settings.payment_method.added.title', 'Changes saved!')
      }
      message={
        wasDeleted
          ? t(
              'l.settings.view.plan_settings.payment_method.deleted.text',
              'Your card was deleted successfully.'
            )
          : t(
              'l.settings.view.plan_settings.payment_method.added.text',
              'Your card was updated successfully.'
            )
      }
      buttonText={t('common.back', 'Back')}
      buttonProps={{ theme: wasDeleted ? 'primary' : 'secondary' }}
    />
  )
}

export const showConfirmModal = createModal(ConfirmPayment, {
  id: 'confirm-payment-method',
  maxWidth: '400px',
  width: '100%',
  showClose: false,
  clickOutside: false
})
